export enum availabilityLeadEvent {
  availabilityLead = "availability_lead"
}
